import React from 'react';
import './style.scss';

const ViewFileDetails = () =>{

    const fileData = [
        {
            id:1,
            title:"Sales order number",
            value:''
        },
        {
            id:2,
            title:"Season year",
            value:'2024'
        },
        {
            id:3,
            title:"Order quantity",
            value:''
        },
        {
            id:4,
            title:"Order date",
            value:'2024-11-04'
        },
        {
            id:5,
            title:"Flag Is Men",
            value:'Yes'
        },
        {
            id:6,
            title:"Product Name",
            value:'Shoulder Bags'
        },
        {
            id:7,
            title:"Material Code",
            value:'40245961-001'
        },
        {
            id:8,
            title:"Flag Is Women",
            value:'Yes'
        },
        {
            id:9,
            title:"Brand Type",
            value:'Mature'
        },
        {
            id:10,
            title:"Material",
            value:'Bags & Acc-Usx-Bags-Shoulder Bags'
        },
        {
            id:11,
            title:"EAN",
            value:'2100015277836'
        },
        {
            id:12,
            title:"Gender",
            value:'Unisex'
        },
        {
            id:13,
            title:"Color",
            value:'black'
        },
        {
            id:14,
            title:"MCH Merchandising c",
            value:'Shoulder Bags'
        },
        {
            id:15,
            title:"Product Type",
            value:'Accessories - Type C'
        },
        {
            id:16,
            title:"ArtHier Department",
            value:'bags & accessories'
        },
        {
            id:17,
            title:"MCH Merchandising c Code",
            value:'M20501013'
        },
        {
            id:18,
            title:"Plus Size",
            value:''
        },
        {
            id:19,
            title:"ArtHier Department Code",
            value:'100'
        },
        {
            id:20,
            title:"Store",
            value:'W001 Poing'
        },
        {
            id:21,
            title:"Barcode",
            value:'2100015277836'
        },
        {
            id:22,
            title:"ArtHier Classifica",
            value:'bag-acc-luxury'
        },
        {
            id:23,
            title:"Store Code",
            value:'W001'
        },
        {
            id:24,
            title:"Is Luxury Yes  No",
            value:'Yes'
        },
        {
            id:25,
            title:"ArtHier Classifica Code",
            value:'10040'
        },
        {
            id:26,
            title:"Storage location",
            value:'X001'
        },
        {
            id:27,
            title:"Product Detail Category ID",
            value:'M20501013'
        },
        {
            id:28,
            title:"Primary size",
            value:'OS'
        },
        {
            id:29,
            title:"Supplying plant",
            value:'Not assigned'
        },
        {
            id:30,
            title:"Product Variant ID",
            value:'40245961-001'
        },
        {
            id:31,
            title:"Brand",
            value:'mcm'
        },
        {
            id:32,
            title:"Supplying plant Code",
            value:'No'
        },
        {
            id:33,
            title:"expFileCount",
            value:'-'
        },
        
        {
            id:34,
            title:"Brand Code",
            value:'-'
        },
        {
            id:35,
            title:"Sales price cluster",
            value:'>= 500.0 and < 1000.0'
        },
        {
            id:36,
            title:"_Product Variant",
            value:'40245961'
        },
        {
            id:37,
            title:"Season",
            value:'fall/wint'
        },
        {
            id:38,
            title:"Luxury flag",
            value:'Yes'
        },
        {
            id:39,
            title:"Special Category Name",
            value:'Luxury Model'
        },
        {
            id:40,
            title:"Season Code",
            value:''
        },
        
        {
            id:41,
            title:"NAV article",
            value:''
        },
    ]

    return(
        <div className='view_file_details'>
            <div className='file_details_body'>
                <div className='listing_details'>
                    {
                        fileData?.map((item)=>{
                            return(
                                <div className='item_details'>
                                    <h2>{item.title}: <span>{item.value}</span></h2>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default ViewFileDetails;